import { flashList } from '@/mocks/news';

export default function LiveTicker() {
  const loop = [...flashList, ...flashList];
  return (
    <div className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto flex w-full items-center gap-4 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 py-3 text-xs font-label text-primary-400">
          <i className="ri-live-line text-base" />
          快讯
        </span>
        <span className="hidden h-4 w-px shrink-0 bg-background-300 md:block" />
        <div className="relative min-w-0 flex-1 overflow-hidden py-3">
          <div className="ticker-track flex w-max items-center gap-8 whitespace-nowrap">
            {loop.map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="flex items-center gap-2 text-xs text-foreground-600"
              >
                <i className="ri-flashlight-line text-accent-500" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}